// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MpnH","label":"styles_label__3DNZe"};